import type { ReactNode } from 'react';
import { Button } from './Button.js';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function Modal({ open, onClose, title, children, footer }: ModalProps) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-xl border p-6"
        style={{
          backgroundColor: 'var(--ac-surface)',
          borderColor: 'var(--ac-border)',
          color: 'var(--ac-text)',
        }}
      >
        {title ? <h2 className="text-lg font-semibold mb-4">{title}</h2> : null}
        <div>{children}</div>
        <div className="mt-6 flex justify-end gap-2">
          {footer ?? (
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
